// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"global-loader-component_loaderContainer__11zWU","loader":"global-loader-component_loader__1ec4z","load7":"global-loader-component_load7__214Cr"};